import React from "react";

import { getImage, ImageType } from "../../../../helpers/imageHelper";
import { useString, useStrings } from "../../../../localization/localizationHelpers";

import * as styles from "./PartnerStoriesSection.module.css";

type StoryCardProps = Readonly<{
  backgroundImage: string;
  boxArt: string;
  studio: string;
  game: string;
  quote: string;
}>;

const StoryCard = ({ backgroundImage, boxArt, studio, game, quote }: StoryCardProps) => {
  const artAlt = useString("landingStoriesArtAlt", game);
  const boxArtAlt = useString("landingStoriesBoxArtAlt", game);

  return (
    <article className={styles.card}>
      <div className={styles.background}>
        <img className={styles.backgroundImage} src={backgroundImage} alt={artAlt} />
      </div>
      <div className={styles.content}>
        <blockquote className={styles.quote}>{quote}</blockquote>
        <div className={styles.studioRow}>
          <img className={styles.boxArt} src={boxArt} alt={boxArtAlt} />
          <div className={styles.studioText}>
            <span className={styles.studio}>{studio}</span>
            <span className={styles.game}>{game}</span>
          </div>
        </div>
      </div>
    </article>
  );
};

export const PartnerStoriesSection = () => {
  const [
    strangeScaffoldStudio,
    strangeScaffoldGame,
    strangeScaffoldQuote,
    aggroCrabStudio,
    aggroCrabGame,
    aggroCrabQuote,
  ] = useStrings(
    "landingStoriesStrangeScaffoldStudio",
    "landingStoriesStrangeScaffoldGame",
    "landingStoriesStrangeScaffoldQuote",
    "landingStoriesAggroCrabStudio",
    "landingStoriesAggroCrabGame",
    "landingStoriesAggroCrabQuote"
  );

  return (
    <section className={styles.section}>
      <div className={styles.cards}>
        <StoryCard
          backgroundImage={getImage("landing_stragescaffold_background_mobile", ImageType.Png)}
          boxArt={getImage("landing_stragescaffold_boxart", ImageType.Png)}
          studio={strangeScaffoldStudio}
          game={strangeScaffoldGame}
          quote={strangeScaffoldQuote}
        />
        <StoryCard
          backgroundImage={getImage("landing_aggrocrab_background_mobile", ImageType.Png)}
          boxArt={getImage("landing_aggrocrab_boxart", ImageType.Png)}
          studio={aggroCrabStudio}
          game={aggroCrabGame}
          quote={aggroCrabQuote}
        />
      </div>
    </section>
  );
};
